<div class="kds-wrapper">

  <!-- Top bar -->
  <div class="kds-topbar">
    <div class="kds-clock">
      <div class="kds-clock-time">{{ currentTime | date:'HH:mm' }}</div>
      <div class="kds-clock-date">{{ currentTime | date:'EEEE · d MMM' }}</div>
    </div>
    <p-selectButton [options]="viewOptions" [(ngModel)]="showCompleted" optionLabel="label" optionValue="value"></p-selectButton>
    <div class="kds-topbar-right">
      <div class="kds-refresh" (click)="loadSales()" title="Refresh">
        <i class="pi pi-refresh"></i>
      </div>
      <button class="kds-back-btn" (click)="exitKDS()">
        <i class="pi pi-arrow-left"></i> Back to System
      </button>
    </div>
  </div>

  <!-- Card template -->
  <ng-template #orderCard let-order>
    <div
      class="kds-card"
      [ngClass]="[showCompleted ? 'card-completed' : getCardUrgencyClass(order.createddate), (!showCompleted && isPriority(order)) ? 'card-priority' : '']">

      <!-- Card header -->
      <div class="kds-card-header">
        <div *ngIf="order.tablenumber" class="kds-table-number">Table {{ order.tablenumber }}</div>
        <div class="kds-card-header-row">
          <div class="kds-card-header-left">
            <span class="kds-order-name">{{ getOrderDisplayName(order) }}</span>
            <span class="kds-order-elapsed">Time Since Order: {{ getElapsedLabel(order.createddate) }}</span>
          </div>
          <div class="kds-card-header-right">
            <span class="kds-completed-badge" *ngIf="showCompleted">
              <i class="pi pi-check-circle"></i> Done
            </span>
          </div>
        </div>
      </div>

      <!-- Items -->
      <div class="kds-items">
        <div *ngFor="let item of kitchenItemsFor(order)" class="kds-item">
          <div class="kds-item-row">
            <span class="kds-item-qty">{{ item.qty ?? 1 }}</span>
            <span class="kds-item-name">{{ getItemName(item) }}</span>
          </div>
          <div *ngIf="getItemOptions(item).length > 0" class="kds-item-options">
            <div *ngFor="let opt of getItemOptions(item)" class="kds-option">
              {{ opt.name }}
            </div>
          </div>
        </div>
      </div>

      <!-- Notes display -->
      <div *ngIf="order.notes" class="kds-notes">
        <i class="pi pi-comment" style="margin-right:6px; opacity:0.6;"></i>{{ order.notes }}
      </div>

      <!-- Card footer -->
      <div class="kds-card-footer">
        <div *ngIf="!showCompleted" style="display:flex; gap:6px;">
          <button
            class="kds-priority-btn"
            [class.kds-priority-btn--active]="isPriority(order)"
            (click)="markPriority(order)">
            <i class="pi pi-bolt"></i> Priority
          </button>
          <button
            class="kds-complete-btn"
            (click)="markComplete(order)">
            <i class="pi pi-check"></i> Complete
          </button>
        </div>
        <button
          *ngIf="showCompleted"
          class="kds-reopen-btn"
          (click)="markReopen(order)">
          <i class="pi pi-undo"></i> Reopen
        </button>
      </div>

      <!-- Amended banner -->
      <div *ngIf="isAmended(order)" class="kds-amended-bar">
        <i class="pi pi-pencil"></i> Amended: {{ order.lastupdated | date:'HH:mm' }}
      </div>

      <!-- Till name bar -->
      <div *ngIf="order.tillname" class="kds-till-bar">
        <i class="pi pi-desktop"></i> {{ order.tillname }}
      </div>

    </div>
  </ng-template>

  <!-- Order cards -->
  <div class="kds-cards-scroll">
    <div class="kds-no-orders" *ngIf="displayedOrders.length === 0">
      <span>{{ showCompleted ? 'No completed orders' : 'No open orders' }}</span>
    </div>

    <ng-container *ngFor="let group of groupedDisplayedOrders">

      <!-- Grouped: multiple orders sharing same table number -->
      <div *ngIf="group.isGroup" class="kds-group">
        <ng-container *ngFor="let order of group.orders">
          <ng-container *ngTemplateOutlet="orderCard; context: { $implicit: order }"></ng-container>
        </ng-container>
      </div>

      <!-- Single order -->
      <ng-container *ngIf="!group.isGroup">
        <ng-container *ngTemplateOutlet="orderCard; context: { $implicit: group.orders[0] }"></ng-container>
      </ng-container>

    </ng-container>
  </div>

</div>

<p-dialog header="Order Notes" [(visible)]="showNotesDialog" [modal]="true" [style]="{width:'420px'}" [draggable]="false" [resizable]="false">
  <textarea
    pInputTextarea
    [(ngModel)]="notesText"
    [autoResize]="true"
    rows="5"
    placeholder="Add notes for this order..."
    style="width:100%; font-size:15px;">
  </textarea>
  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" class="p-button p-element p-button-success" (click)="saveNotes()">
      <span class="pi pi-check" style="margin-right:6px;"></span>Save
    </button>
    <button pButton pRipple type="button" class="p-button p-element p-button-secondary p-button-outlined" style="margin-left:8px;" (click)="showNotesDialog=false">
      <span class="pi pi-times" style="margin-right:6px;"></span>Cancel
    </button>
  </ng-template>
</p-dialog>
